"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionPanel = exports.Accordion = void 0;
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var Accordion_1 = __importDefault(require("./Accordion"));
var AccordionPanel_1 = __importDefault(require("./AccordionPanel"));
exports.Accordion = Accordion_1["default"];
exports.AccordionPanel = AccordionPanel_1["default"];
(0, spaui_utils_1.setComponentMark)(exports.Accordion, info_1["default"]);
(0, spaui_utils_1.setComponentMark)(exports.AccordionPanel, info_1["default"]);
exports["default"] = {
  Accordion: exports.Accordion,
  AccordionPanel: exports.AccordionPanel
};